export const CONSULTANT_MONTHLY_PATIENT_SCORE_EXTRACT_REQUEST =
	"CONSULTANT_MONTHLY_PATIENT_SCORE_EXTRACT_REQUEST"
export const CONSULTANT_MONTHLY_PATIENT_SCORE_EXTRACT_RECEIVE =
	"CONSULTANT_MONTHLY_PATIENT_SCORE_EXTRACT_RECEIVE"
export const CONSULTANT_MONTHLY_PATIENT_SCORE_EXTRACT_FAILURE =
	"CONSULTANT_MONTHLY_PATIENT_SCORE_EXTRACT_FAILURE"
